import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import moment from "moment-timezone";
import { utilities } from "@/_helpers";
import { enrolleeUpdate } from "../../_redux/actions/enrolleeActions";
import {
  createAppointment,
  sendAppointmentConfirmation,
} from "../../_redux/actions/appointmentActions";
import AppointmentLocation from "./appointment/AppointmentLocation";
import AppointmentCalendar from "./appointment/AppointmentCalendar";
import AppointmentTimes from "./appointment/AppointmentTimes";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import Grid from "@mui/material/Grid";
// import { RingLoader } from "@/_components";
import { GridLoader } from "react-spinners";

const formatDateForApi = (date) => moment(date).format("YYYY-MM-DD");

function ScheduleInfo({
  enrollee,
  setScheduleType,
  handleUpdate,
  isSubmitAppointment,
  setIsSubmitAppointment,
  isLoaded,
}) {
  const enrolleeUserData = JSON.parse(sessionStorage.getItem("enrolleeUser"));
  const clientProfiles = JSON.parse(sessionStorage.getItem("clientProfiles"));
  const [apptStep, setApptStep] = useState();
  const [apptInnerStep, setApptInnerStep] = useState();
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);
  const [prefillDeviceType, setPrefillDeviceType] = useState(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  useEffect(() => {
    if (selectedDate) {
      if (isMobile && apptStep === "Calendar" && apptInnerStep === "Times") {
        setApptStep("Times");
      } else if (!isMobile && apptStep === "Times") {
        setApptStep("Calendar");
        setApptInnerStep("Times");
      }
    }
  }, [isMobile]);

  useEffect(() => {
    setApptStep("Location");
  }, []);

  useEffect(() => {
    if (enrolleeUserData) {
      setPrefillDeviceType(
        enrolleeUserData?.clientTypeId === 6 || enrolleeUserData?.deviceType === "Speed" || enrolleeUserData?.deviceType === "ISA"
          ? "ISA"
          : enrolleeUserData?.clientTypeId === 5 || enrolleeUserData?.deviceType === "Portable" || enrolleeUserData?.deviceType === "PAM"
          ? "PAM"
          : "IID"
      );
    }
  }, [enrolleeUserData]);

  useEffect(() => {
    if (apptStep) {
      setScheduleType(apptStep);
    }
  }, [apptStep]);

  const locationSelected = (locationObj) => {
    setSelectedLocation(locationObj);
    setApptStep("Calendar");
  };
  const dateSelected = (date) => {
    setSelectedDate(date);
    isMobile ? setApptStep("Times") : "";
    setApptInnerStep("Times");
  };
  const goBackAStep = (step) => {
    setApptStep(step);
    setApptInnerStep(null);
  };

  const createNewAppointment = (hour, bay) => {

    const appointmentDateTime = `${formatDateForApi(
      selectedDate,
    )} ${utilities.convertTo24H(hour)}`;
    let apptDTFormatted =
      utilities.getMonthName(selectedDate) + " " + selectedDate.getDate();

    let isVehicleClient =
      enrolleeUserData?.clientTypeId === 1 ||
      enrolleeUserData?.clientTypeId === 6;

    let appointmentData = {
      appointmentID: 0,
      vehicleID: isVehicleClient ? enrolleeUserData?.vehicleId : 0,
      clientID: enrolleeUserData?.clientId,
      beginDT: appointmentDateTime,
      appointmentDate: apptDTFormatted,
      appointmentTime: hour,
      serviceID:
        enrolleeUserData?.clientTypeId === 1
          ? 1
          : enrolleeUserData?.clientTypeId === 5
          ? 290
          : enrolleeUserData?.clientTypeId === 6
          ? 396
          : 0,
      appointmentStatusID: 1,
      appointmentType: "Installation",
      locationID: selectedLocation.locationID,
      bayID: bay,
      locationName: selectedLocation.displayName,
      address1: selectedLocation.address1,
      address2: selectedLocation.address2,
      city: selectedLocation.city,
      state: selectedLocation.state,
      zip: selectedLocation.zip,
      deviceType:
        enrolleeUserData?.clientTypeId === 1
          ? "IID"
          : enrolleeUserData?.clientTypeId === 5
          ? "PAM"
          : enrolleeUserData?.clientTypeId === 6
          ? "ISA"
          : "IID",
      vehYear: isVehicleClient ? enrolleeUserData?.vehYear : 0,
      make: isVehicleClient ? enrolleeUserData?.make : "",
      model: isVehicleClient ? enrolleeUserData?.model : "",
      isFranchise: false,
    };

    handleUpdate("Schedule", appointmentData);
    //For Future Use
    // createAppointment(appointmentData)
    //   .then((newAppointment) => {
    //     if (newAppointment.appointmentID > 0) {
    //       // 1. Ensure we know there's an appointment so duplication can't happen
    //       let updatedData = {
    //         HasAppt: true,
    //       };
    //         ...enrolleeUser,
    //         ...updatedData,
    //       };
    //       cookies.set("lifesaferEnrollment", JSON.stringify(updatedUser), {
    //         path: "/",
    //         sameSite: "strict",
    //         expires: new Date(moment().add(15, "m").format()),
    //       });
    //       // 2. Update Enrollee Table with Complete Date & Time Stamp
    //       let newData = {
    //         complete: true,
    //         step: "Appointment",
    //       };
    //       let updatedEnrolleeObj = { ...enrollee, ...newData };

    //       enrolleeUpdate(updatedEnrolleeObj).then(() => {
    //         // 3. Send Appointment Confirmation Email
    //         let confirmationObj = {
    //           AppointmentID: newAppointment.appointmentID,
    //           LocationID: newAppointment.locationID,
    //           BrandIdentifier: brand === Monitech ? "monitechiid" : brand,
    //         };
    //         sendAppointmentConfirmation(confirmationObj)
    //           .then(() => {
    //             // 4. Success & Move on!
    //             // toast.success(t("outro.apptSaveSuccess"));
    //             setStep(4);
    //           })
    //           .catch((error) => {
    //             // 4alt. Even if the email fails, let's toast success & move on
    //             console.log("Confirmation email didn't send. " + error);
    //             // toast.success(t("outro.apptSaveSuccess"));
    //             setStep(4);
    //           });
    //       });
    //     } else {
    //       // toast.error(t("outro.apptSaveFailure"));
    //       setStep(1);
    //     }
    //   })
    //   .catch((error) => {
    //     console.log("Appointment save failed! " + error);
    //     // toast.error(t("outro.apptSaveFailure"));
    //     setStep(3);
    //   });
  };

  return (
    <>
      {isSubmitAppointment === true ? (
        <>
          <Grid
            container
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
              height: "100%",
            }}
          >
            <Grid>
              <GridLoader />
            </Grid>
          </Grid>
        </>
      ) : (
        <>
          <div
            style={{
              width: "100%",
              marginTop: "25px",
              marginLeft: "10px",
              marginRight: "10px",
            }}
          >
            <Grid container>
              <Grid size={12}>
                {apptStep === "Location" ? (
                  <AppointmentLocation
                    selectedLocation={locationSelected}
                    enrolleeUserData={enrolleeUserData}
                    prefillDeviceType={prefillDeviceType}
                    userData={clientProfiles}
                    isLoaded={isLoaded}
                  />
                ) : apptStep === "Calendar" ? (
                  <div style={{ display: "flex", justifyContent: "center" }}>
                    <AppointmentCalendar
                      appointmentLocation={selectedLocation}
                      unitType={enrollee.device}
                      selectedDate={selectedDate}
                      setSelectedDate={dateSelected}
                      previousStep={goBackAStep}
                      enrolleeUserData={enrolleeUserData}
                      prefillDeviceType={prefillDeviceType}
                    />
                    {!isMobile && apptInnerStep === "Times" && selectedDate && (
                      <AppointmentTimes
                        appointmentLocation={selectedLocation}
                        unitType={enrollee.device}
                        selectedDate={selectedDate}
                        setSelectedDate={dateSelected}
                        previousStep={goBackAStep}
                        makeAppointment={createNewAppointment}
                        enrolleeUserData={enrolleeUserData}
                        prefillDeviceType={prefillDeviceType}
                        dynamicWidth={190}
                        isShowTimeWeb={false}
                        setIsSubmitAppointment={setIsSubmitAppointment}
                      />
                    )}
                  </div>
                ) : isMobile && apptStep === "Times" ? (
                  <div style={{ display: "flex", justifyContent: "center" }}>
                    <AppointmentTimes
                      appointmentLocation={selectedLocation}
                      unitType={enrollee.device}
                      selectedDate={selectedDate}
                      setSelectedDate={dateSelected}
                      previousStep={goBackAStep}
                      makeAppointment={createNewAppointment}
                      enrolleeUserData={enrolleeUserData}
                      prefillDeviceType={prefillDeviceType}
                      dynamicWidth={380}
                      isShowTimeWeb={true}
                      setIsSubmitAppointment={setIsSubmitAppointment}
                    />
                  </div>
                ) : null}
              </Grid>
            </Grid>
          </div>
        </>
      )}
    </>
  );
}

ScheduleInfo.propTypes = {
  enrollee: PropTypes.object.isRequired,
  enrolleeUpdate: PropTypes.func,
  createAppointment: PropTypes.func,
  setScheduleType: PropTypes.func,
  sendAppointmentConfirmation: PropTypes.func,
  setStep: PropTypes.func.isRequired,
  handleUpdate: PropTypes.func,
  isSubmitAppointment: PropTypes.bool,
  setIsSubmitAppointment: PropTypes.func,
  isLoaded: PropTypes.func,
};

function mapStateToProps(state) {
  return {
    enrollee: state.enrollee,
  };
}
const mapDispatchToProps = {
  createAppointment,
  sendAppointmentConfirmation,
  enrolleeUpdate,
};

export default connect(mapStateToProps, mapDispatchToProps)(ScheduleInfo);
